import { IonApp, IonRouterOutlet, IonSplitPane, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Redirect, Route } from 'react-router';
import Menu from './components/Menu';
import LessonPage from './pages/LessonPage/LessonPage';
import LessonIndexPage from './pages/LessonIndexPage/LessonIndexPage';
import InitialPage from './pages/InitialPage/InitialPage';
import Questionnaire from './pages/QuestionnairePage/Questionnaire';
import ChatPage from './pages/ChatPage/ChatPage';
import SettingsPage from './pages/SettingsPage/SettingsPage';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/**
 * Ionic Dark Mode
 * -----------------------------------------------------
 * For more info, please see:
 * https://ionicframework.com/docs/theming/dark-mode
 */

/* import '@ionic/react/css/palettes/dark.always.css'; */
/* import '@ionic/react/css/palettes/dark.class.css'; */
import '@ionic/react/css/palettes/dark.system.css';

/* Theme variables */
import './theme/variables.css';
import UserBooksPage from './pages/UserBooksPage/UserBooksPage';
import UserBookPage from './pages/UserBookPage/UserBookPage';
import BillingPage from './pages/BillingPage/BillingPage';

setupIonicReact();

const App: React.FC = () => {
  return (
    
    <IonApp>
      <IonReactRouter>
        <IonSplitPane contentId="main">
          <Menu />
          <IonRouterOutlet id="main">
            <Route path="/" exact={true}>
              <Redirect to="/docs" />
            </Route>
            <Route path="/docs" component={UserBooksPage} exact={true} />
            <Route path="/docs/:doc_id/:doc_name" component={UserBookPage} exact={true} />
            <Route path="/docs/:doc_id/:doc_name/:chapter_lesson_id" component={LessonPage} exact={true} />
            <Route path="/folders/:folder_id/*" component={UserBooksPage} exact={false} />
            <Redirect exact from="/docs/:repo_id" to="/docs" />
            <Route path="/billing" component={BillingPage} exact={false} />
            <Route path="/lessons" exact={true}>
              <LessonIndexPage />
            </Route>
            <Route path="/lessons/:id" component={LessonPage} />
            <Route path="/quizes" exact={true}>
              <LessonIndexPage />
            </Route>
            <Route path="/feedback" exact={true}>
              <LessonIndexPage />
            </Route>
            <Route path="/progress" exact={true}>
              <LessonIndexPage />
            </Route>
            <Route path="/profile" exact={true}>
              <LessonIndexPage />
            </Route>
            <Route path="/settings" component={SettingsPage} />


            <Route path="/initial" exact={true}>
              <InitialPage />
            </Route>
            <Route path="/questionnaire" exact={true}>
              <Questionnaire />
            </Route>
            <Route path="/chat" exact={true}>
              <ChatPage />
            </Route>
          </IonRouterOutlet>
        </IonSplitPane>
      </IonReactRouter>
    </IonApp>
  );
};

export default App;
